/**
 * Breakpoint values synchronized with theme.less
 * @see theme.less - @media-mobile: 768px, @media-default/@media-large: 1366px
 *
 * IMPORTANT: Keep these values in sync with theme.less
 */
export const BREAKPOINTS = {
  MOBILE: 768,
  DESKTOP: 1366
} as const;

export const MEDIA_QUERIES = {
  MOBILE: `(max-width: ${BREAKPOINTS.MOBILE}px)`,
  DESKTOP: `(max-width: ${BREAKPOINTS.DESKTOP}px)`,
  DESKTOP_LARGE: `(min-width: ${BREAKPOINTS.DESKTOP}px)`
} as const;
